import { render, staticRenderFns } from "./MyQnaForm.vue?vue&type=template&id=2e9bf6a0&"
import script from "./MyQnaForm.vue?vue&type=script&lang=js&"
export * from "./MyQnaForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports